import React from 'react';
import PropTypes from 'prop-types';
import ProductCard from './ProductCard';

const RelatedProducts = ({ products, onAddToCart }) => {
  if (!products || products.length === 0) return null;

  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {products.map((product) => (
          <ProductCard
            key={product._id}
            product={product}
            onAddToCart={() => onAddToCart(product)}
          />
        ))}
      </div>
    </div>
  );
};

RelatedProducts.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      price: PropTypes.number.isRequired,
      images: PropTypes.array,
      category: PropTypes.string
    })
  ),
  onAddToCart: PropTypes.func
};

export default RelatedProducts;